import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 1rem;
  width: 5rem;

  svg {
    height: auto;
    width: 100%;
  }

  ${(props) => props.scale && css`
    margin-bottom: ${props.scale}rem;
    width: ${props.scale * 5}rem;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/LystLogo/style.js